import ApplicationController from 'javascript/controllers/application_controller';

export default class extends ApplicationController {
  static targets = ['submitButton'];

  disable(event) {
    if (this.hasSubmitButtonTarget) {
      this.submitButtonTarget.setAttribute('disabled', 'disabled');
      this.submitButtonTarget.classList.add('button--loading');
    }
  }
}
